import { z } from 'zod'

import { fileNameSchema } from '../../entities/file'

export const ALLOWED_CONTENT_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
  'text/plain',
  'text/csv',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  // Common video formats. `video/quicktime` covers .mov files.
  'video/mp4',
  'video/quicktime',
  'video/webm',
] as const

/** Maximum file size: 50 MB. */
export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024

/** Maximum number of files that can be attached in a single request/form submission. */
export const MAX_FILE_ATTACHMENTS = 25

export const fileContentTypeSchema = z.enum(ALLOWED_CONTENT_TYPES, {
  message: 'File type not allowed',
})

export const fileResponseSchema = z.object({
  id: z.string(),
  fileName: fileNameSchema,
  contentType: z.string(),
  sizeBytes: z.number().nullable(),
})

export type FileResponse = z.infer<typeof fileResponseSchema>

/**
 * Query params for the download URL endpoint. `disposition` controls whether the
 * presigned URL displays the file inline (preview) or forces a browser download.
 * Defaults to inline when omitted.
 */
export const getFileDownloadUrlQuerySchema = z.object({
  disposition: z.enum(['inline', 'attachment']).optional(),
})

export type GetFileDownloadUrlQuery = z.infer<typeof getFileDownloadUrlQuerySchema>

export const postFileUploadUrlBodySchema = z.object({
  fileName: fileNameSchema,
  contentType: fileContentTypeSchema,
})

export type PostFileUploadUrlBody = z.infer<typeof postFileUploadUrlBodySchema>
